export default function LocationMap() {
  return (
    <div className="h-[300px] rounded-lg overflow-hidden border border-gray-200">
      <iframe
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3007.1776212685822!2d28.980705699999998!3d41.0869656!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14cabb966101876b%3A0x56c4a5f7f0b715d!2sDentaWista%20Clinic!5e0!3m2!1sen!2sca!4v1747759716774!5m2!1sen!2sca"
        width="100%"
        height="100%"
        style={{ border: 0 }}
        loading="lazy"
        title="Clinic Location"
        allowFullScreen
        referrerPolicy="no-referrer-when-downgrade"
      ></iframe>
    </div>
  );
}
